<script lang="ts">
  import { workQueueTab, openWorkQueue, type WorkQueueTab } from '../lib/stores/ui';

  interface Props {
    backlogCount: number;
  }

  let { backlogCount }: Props = $props();

  function select(tab: WorkQueueTab) {
    openWorkQueue(tab);
  }
</script>

<div class="work-queue-tabs" role="tablist" aria-label="Work queue view">
  <button
    type="button"
    role="tab"
    class:active={$workQueueTab === 'backlog'}
    aria-selected={$workQueueTab === 'backlog'}
    onclick={() => select('backlog')}
  >
    Backlog <span class="tab-count">{backlogCount}</span>
  </button>
  <button
    type="button"
    role="tab"
    class:active={$workQueueTab === 'priority'}
    aria-selected={$workQueueTab === 'priority'}
    onclick={() => select('priority')}
  >
    Priority tasks
  </button>
</div>

<style>
  .work-queue-tabs {
    display: flex;
    gap: 0.25rem;
    margin-top: 0.5rem;
  }

  button {
    border: 1px solid transparent;
    border-radius: 0.25rem;
    background: #f3f4f6;
    color: #6b7280;
    cursor: pointer;
    font: inherit;
    font-size: 0.625rem;
    font-weight: 600;
    padding: 0.25rem 0.375rem;
  }

  button:hover {
    background: #e5e7eb;
    color: #374151;
  }

  button.active {
    background: #eff6ff;
    border-color: #bfdbfe;
    color: #2563eb;
  }

  .tab-count {
    color: currentColor;
    font-size: 0.5625rem;
    opacity: 0.75;
  }

  /* Mobile: the tabs sit in the work-queue bottom sheet. */
  @media (max-width: 767px) {
    button {
      flex: 1;
      min-height: var(--mobile-tap);
      font-size: 0.8125rem;
    }

    .tab-count {
      font-size: 0.75rem;
    }
  }
</style>
